const FaceTryonSceneInit = () => {
  return (
    <a-scene
      embedded
      vr-mode-ui="enabled: false"
      xr-mode-ui="enabled: false"
      renderer="logarithmicDepthBuffer: true;"
      gltf-model="dracoDecoderPath: https://rhym.s3.ap-south-1.amazonaws.com/draco/"
      id="scene"
    >
      <a-assets>
        <a-mixin
          id="text"
          text="align: center; width: 20;
                 value: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam"
        ></a-mixin>
      </a-assets>
      <a-entity
        id="webar_stage"
        grid="size: 10; divisions: 10; color: #00F; opacity: 0.3"
        position="2 -0.5 0"
        rotation="0 0 0"
        scale="1 1 1"
      >
        <a-entity>
          <a-entity id="entity_elements"></a-entity>
        </a-entity>
      </a-entity>
      <a-entity
        cursor="rayOrigin: mouse"
        raycaster="objects: .clickable"
      ></a-entity>
      <a-camera
        position="0 0 10"
        tone-mapping="algorithm: reinhard;"
        look-controls="magicWindowTrackingEnabled: false; touchEnabled: false; mouseEnabled: false"
      ></a-camera>
    </a-scene>
  );
};

export default FaceTryonSceneInit;
